import React, { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { IconButton, Switch } from "@mui/material";
import Header from "../Header/Header1";
// import ApexChart from './Apexchart'
import Tradeview from "./Tradeview";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./Trade.scss";
import OrderBook from "./OrderBook";
import { useTheme, useMediaQuery } from "@mui/material";
import Placeorder from "./Placeorder";
import Modal from "@mui/material/Modal";
import { styled } from '@mui/material/styles';
import Slide from "@mui/material/Slide";
import FormControlLabel from '@mui/material/FormControlLabel';
import nodata from "../../Img/thankyou.gif";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Btcoin from "../../Img/btcoin.png";
import Loader from "../Loader";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Drawer from "@mui/material/Drawer";
import {
  Drop,
  Drop2,
  Info,
  M1,
  M2,
  M3,
  Msg,
  Trading,
  Wifi,
} from "../../SvgCollection";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TradeHistory from "./TradeHistory";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    left: '2px',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#566FFF',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 14,
    height: 13,
    left: '2px',
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#ccc',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },

}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "12%",
  left: "0%", // Start from the left side of the screen
  transform: "translateY(-50%)", // Center vertically
  width: 600,
  bgcolor: "var(--model)",
  // border: '2px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 2,
  "@media (max-width: 767.98px)": {
    width: "90%",
    left: "0%",
  },
};

function Trade(props) {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));
  // console.log(isLgUp, "leg");

  // State
  const [defLayout, setDefLayout] = useState('professional')

  const [tabs, setTabs] = useState([
    { id: 1, label: "Chart", visible: true },
    { id: 2, label: "Market depth", visible: true },
    { id: 3, label: "Order Book", visible: true },
    { id: 4, label: "Recent order", visible: true },
    { id: 5, label: "open orders", visible: true },
    { id: 6, label: "order history", visible: true },
    { id: 7, label: "trdae history", visible: true },
    { id: 8, label: "positions", visible: true },
    { id: 9, label: "place order", visible: true },
    { id: 10, label: "Asset Overview", visible: true },
  ]);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [value5, setValue5] = useState(0);

  const handleChange5 = (event, newValue) => {
    setValue5(newValue);
  };

  const [value6, setValue6] = useState(0);

  const handleChange6 = (event, newValue) => {
    setValue6(newValue);
  };

  const [quoteCoin, setQuoteCoin] = useState("USDT");
  const [type, setType] = useState("spot");

  const [value7, setValue7] = useState(0);

  const handleChange7 = (event, newValue) => {
    const tabLabels = ["USDT", "USDC", "BTC", "ETH"];
    setValue7(newValue);
    setQuoteCoin(tabLabels[newValue]);
  };
  const [value8, setValue8] = useState(0);

  const handleChange8 = (event, newValue) => {
    setValue8(newValue);
  };

  const [valueTab2, setValueTab2] = useState(0);

  const handleChangeTab2 = (event, newValue) => {
    const tabLabels = ["spot", "future", "spot"];
    // console.log("Selected Tab Label:", tabLabels[newValue]); // Log the label of the selected tab
    setValueTab2(newValue);
    setType(tabLabels[newValue]);
  };

  const [openLayout, setOpenLayout] = useState(false);
  const toggleDrawerLayout = (newOpen) => () => {
    setOpenLayout(newOpen);
  };

  // console.log(openLayout, "openLayout");

  const DrawerList = (
    <Box sx={{ width: 420, p: 1 }} role="presentation">
      <Box marginBottom={0} sx={{ p: 1, borderBottom: '1px solid #cccccc36' }}>
        <div className="display-2 p-10">
          <div className="select-form">Layout</div>
          <div className="display-1">
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              className="cursor"
              onClick={toggleDrawerLayout(false)}
            />
          </div>
        </div>
      </Box>
      <div className="p-10 mt-20" style={{ borderBottom: '1px solid #cccccc36' }}>
        <div className="deflayout-h">Default Layout</div>
        <div className="display-3 flex-wrap def-lay-svg">
          <div className={defLayout === "classic" ? 'svg-actv class-name' : 'class-name'} onClick={() => setDefLayout("classic")}>
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="classic-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="34"
                y="40"
                width="60"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="65"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="47"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Classic</div>
          </div>

          <div className={defLayout === "professional" ? 'svg-actv class-name' : 'class-name'} onClick={() => setDefLayout("professional")}>
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="advanced-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="91"
                y="11"
                width="26"
                height="58"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="96"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
              <rect
                x="105"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="96"
                y="44"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Professional</div>
          </div>

          <div className={defLayout === "fullscreen" ? 'svg-actv class-name' : 'class-name'} onClick={() => setDefLayout("fullscreen")}>
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="fullscreen-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="69"
                y="40"
                width="48"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="94"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="76"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Full Screen</div>
          </div>
        </div>
        <div className="deflayout-h mt-20">Custom Layout</div>
        <div className="  def-lay-svg ">
          <div className={'custm-lay'} onClick={() => setDefLayout("fullscreen")}>
            <div className="cust-svg">
              <AddCircleOutlineIcon sx={{ color: '#cccccc36' }} />
            </div>
            <div className="class-name mt-10">
              Create
            </div>
          </div>

        </div>
      </div>

      <div className="p-10 mt-20">
        <div className="display-2">
          <div className="deflayout-h" style={{ textTransform: 'capitalize' }}>
            {defLayout}
          </div>
          <div className="deflayout-h cursor" style={{ textTransform: 'capitalize', color: '#566FFF' }}>
            Restore to Default
          </div>
        </div>
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>
            <FormControlLabel
              // checked={tab.visible}
              control={<AntSwitch sx={{ my: 2, mx: 1 }} defaultChecked
              // onChange={() => handleToggleTab(tab.id)}
              />}
            // label="iOS style"
            />
          </Box>
        ))}
      </div>
    </Box>
  );

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  /*drawer */

  const [bysel, setBysel] = useState(null);

  // console.log(bysel, "bysel");
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [pairsList, setPairsList] = useState([
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
  ]);

  const midpoint = Math.floor(pairsList.length / 2);

  const [activeTab, setActiveTab] = useState("Standard");
  return (
    <div className="Tradepage">
      <div className="trd_head">
        <Header />
      </div>
      {/* <Loader /> */}
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="padding-10 grid-box">
            <div className="display-2">
              <div
                className="display-1"
                style={{
                  gap: !mobilemd ? "20px" : "40px",
                  overflowY: !mobilemd && "scroll",
                  paddingLeft: "15px",
                }}
              >
                <div
                  className="select-form display-1 cursor"
                  onClick={handleOpen}
                >
                  <Drop />
                  <img src={Btcoin} alt="Btcoin" className="Btcoin" />
                  <div>
                    BTC/USDT
                    <div className="d-flex gap-10 about-coin">
                      <span
                        className="about-coin-name"
                        style={{
                          whiteSpace: "nowrap",
                          borderBottom: "dashed 1px",
                        }}
                      >
                        Bitcoin
                      </span>
                      <span>|</span>
                      <span
                        className="about-coin-network"
                        style={{
                          whiteSpace: "nowrap",
                          borderBottom: "dashed 1px",
                        }}
                      >
                        BTC Network
                      </span>
                    </div>
                  </div>
                </div>

                {/* <Info className='cursor' /> */}
                <div
                  className="display-5"
                  style={{
                    gap: "30px",
                    width: "auto",
                    overflowY: !sm && "scroll",
                  }}
                >
                  <div className="total-data">
                    66,912.2
                    <div className="total-sub">
                      -2.16%<span>-1,479.6</span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h change
                    <div className="lh-sub" style={{ color: "#f66754" }}>
                      -1.09%
                    </div>
                  </div>
                  <div className="lh-24">
                    24h High
                    <div className="lh-sub">68,491.9</div>
                  </div>

                  <div className="lh-24">
                    24h Low
                    <div className="lh-sub">68,491.9</div>
                  </div>

                  <div className="lh-24">
                    24h Amount (BTC)
                    <div className="lh-sub">2.05K</div>
                  </div>
                </div>
              </div>
              <div className="display-1" style={{ gap: "20px" }}>
                <Wifi />

                <div className="hoz-des"></div>

                <div className="display-1 lh-sub">
                  <Msg />
                  News
                </div>

                <div className="display-1 lh-sub">
                  <Trading />
                  Trading Info
                </div>

                <div className="hoz-des"></div>
                <M1 />
                <div onClick={toggleDrawerLayout(true)} className="cursor">
                  <M2 />
                </div>

                <M3 />
              </div>
            </div>
          </div>
        </Grid>
        <Grid xs={12} sm={12} md={12} lg={9} xl={9.5}>
          <Grid container spacing={1}>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={8}
              xl={9}
              className="trade-charts"
            >
              <Box sx={{ width: "100%" }} className="grid-box">
                {/* <Box sx={{ padding: "10px 0px" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="tabs-trade"
                  >
                    <Tab label="Chart" {...a11yProps(0)} /> 
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <Tradeview />
                </CustomTabPanel> */}
                <div className="chart_tabs">
                  {/* Tabs */}
                  <div className="c_tabs">
                    {/* <div>
                      <button className={`chart_button chart`}>Chart</button>
                    </div> */}
                    <div>
                      {tabs.slice(0, 2).map((row, i) => {
                        return (

                          <button
                            className={`chart_button ${activeTab === "Standard" ? "active" : ""
                              }`}
                            onClick={() => setActiveTab("Standard")}
                          >
                            {row.label}      <CloseIcon sx={{ fill: "#ccc", fontSize: '12px' }} />
                          </button>
                        )
                      })}
                      {/* <button
                        className={`chart_button ${
                          activeTab === "TradingView" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("TradingView")}
                      >
                        Market Depth
                      </button> */}
                      {/* <button
                        className={`chart_button ${
                          activeTab === "Depth" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("Depth")}
                      >
                        Depth
                      </button> */}
                    </div>
                  </div>

                  {/* Tab Content */}
                  <div className="tabs_content">
                    {activeTab === "Standard" && (
                      <div>
                        <Tradeview />
                      </div>
                    )}
                    {activeTab === "TradingView" && (
                      <div>
                        <Tradeview />
                      </div>
                    )}
                    {activeTab === "Depth" && (
                      <div>Adjust your settings here.</div>
                    )}
                  </div>
                </div>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={4} xl={3}>
              <OrderBook />
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <TradeHistory />
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} sm={12} md={12} lg={3} xl={2.5}>
          <Placeorder />
        </Grid>
      </Grid>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="modal-box-cnt"
      >
        <Slide in={open} direction="right">
          <Box sx={{ ...style }} className="modal-trade">
            <div className="text-right">
              <HighlightOffIcon
                sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
                onClick={handleClose}
              />
            </div>
            <div className="mt-10">
              <div class="group">
                <svg viewBox="0 0 24 24" aria-hidden="true" class="search-icon">
                  <g>
                    <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                  </g>
                </svg>

                <input
                  id="query"
                  class="input"
                  type="search"
                  placeholder="Search..."
                  name="searchbar"
                />
              </div>
            </div>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ margin: "10px 0" }}>
                <Tabs
                  value={valueTab2}
                  onChange={handleChangeTab2}
                  aria-label="basic tabs example"
                  className="tabs-trade"
                >
                  <Tab label="spot" {...a11yProps(0)} />
                  <Tab label="Margin" {...a11yProps(2)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTab2} index={0}>
                <Box sx={{ width: "100%" }}>
                  <Box>
                    <Tabs
                      value={value7}
                      onChange={handleChange7}
                      aria-label="basic tabs example"
                      className="tabs-trade"
                    >
                      <Tab label="USDT" {...a11yProps(0)} />
                      <Tab label="USDC" {...a11yProps(1)} />
                      <Tab label="BTC" {...a11yProps(2)} />
                      <Tab label="ETH" {...a11yProps(3)} />
                    </Tabs>
                  </Box>

                  <CustomTabPanel className="cust-box">
                    <TableContainer className="trade-left-table model">
                      <Table aria-label="simple table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              Trading Pairs/Vol{" "}
                            </TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">24H Change</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pairsList?.length > 0 &&
                            pairsList?.map((row, ind) => (
                              <TableRow
                                key={ind}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                className={
                                  ind > midpoint ? "tr-green" : "tr-red"
                                }
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                >
                                  <div
                                    className="select-form display-1 cursor"
                                    onClick={handleOpen}
                                  >
                                    <img
                                      src={Btcoin}
                                      alt="Btcoin"
                                      className="Btcoin"
                                    />
                                    BTC/USDT
                                  </div>
                                </TableCell>

                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                >
                                  {row.n1}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                >
                                  {row.n1}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CustomTabPanel>
                </Box>
              </CustomTabPanel>
            </Box>
          </Box>
        </Slide>
      </Modal>
      <Drawer
        anchor="right"
        open={openLayout}
        onClose={toggleDrawerLayout(false)}
        className="layout-draw"
      >
        {DrawerList}
      </Drawer>
    </div>
  );
}

export default Trade;
